import {StarOutlined} from '@ant-design/icons'
import DrawMenu from 'components/drawer/DrawMenu'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {NullAsDefault} from 'views/Shared'
import {HiOutlineMenu} from "react-icons/hi";
import {LoginContext} from "../../../components/LoginContext";

const defaultActions = [
    {
        key: 'action-1',
        label: 'action 1',
        icon: <StarOutlined/>,
    },
    {
        key: 'action-2',
        label: 'action 2',
        icon: <StarOutlined/>,
    },
    {
        key: 'action-3',
        label: 'action 3',
        icon: <StarOutlined/>,
    },
]

const ActionMenu = ({onClick = NullAsDefault, actions = defaultActions}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)


    const handleClick =
        (callback = NullAsDefault) =>
            ({key}) => {
                onClick(key)
                callback()
            }

    const items = useMemo(() =>
            (actions || [])
                .filter(e => {
                    if (e.isInvisible) return !e.isInvisible({ login });
                    return true;
                })
                .map(e => ({
                    key: e.key,
                    icon: e.icon,
                    label: (
                        <span className="font-medium text-sm text-color-100">
          {t(e.label)}
        </span>
                    ),
                })),
        [actions, t, login]
    );

    return (
        <DrawMenu
            menu={
                {
                    items: items,
                    onClick: handleClick(),
                }
            }
            component={
                <div className="flex flex-center">
                    <HiOutlineMenu size={21} className="text-gray-700 hover:text-primary-600 cursor-pointer"/>
                </div>
            }>
        </DrawMenu>
    )
}

export default ActionMenu
